const CardMap = {
    "国内热门": "simple",
    "国内降价榜": "price",
    "国内低价榜": "rank",
    "拥抱自然": "picture",
    "海边浪一浪": "picture",
    "人文历史": "picture",
    "草原风光":"picture",
    "文艺古镇":"picture"
};

const isDoubleColumn = ["simple", "price", "picture"];

function groupList (list, num = 2) {
    if (!list || !list.length) {
        return [];
    }

    list.forEach((product, index) => {
        product.index = index;
    });
    if(list.length % 2 !== 0) {
        list.length = list.length - 1 ;
    }

    let result = [];
    for (let i = 0; i < list.length; i += num) {
        result.push(list.slice(i, i + num));
    }

    return result;
}

function getShowType(item) {
    if(!item || !item.title) {
        return "simpleCard"
    }
    return CardMap[item.title];

}

export function handleLowPriceData(data) {
    let retData = {};
    let {items, filters} = data || {};
    let hasItems = items && items.length;

    retData.items = hasItems
        ? items.map((item) => {
            const {flightInfoList, title, bgPicUrl, itemTopBgPicUrl, tabJumpUrl, titleCat} = item || {};
            let showType = getShowType(item);
            return {
                anchor: title,
                title,
                bgPicUrl,
                itemTopBgPicUrl,
                tabJumpUrl,
                titleCat,
                flightInfoList: flightInfoList || [],
                showType,
                isDoubleColumn: isDoubleColumn.indexOf(showType) > -1,
                groupedList: groupList(flightInfoList)
            }
        })
        : [];

    retData.filters = filters;
    return retData;

}